import React, { Component } from 'react';
import { connect } from 'react-redux';
import { findIndex } from 'lodash';
import WidgetLayoutManualModal from '../../../../views/widget/common/modal/WidgetLayoutManualModal';
import withModal from '../../../../lib/hoc/withModal';
import { widgetActions } from '../../../../store/modules/widget';
import {
  checkBrandAndBannerWidgetSelectedWidgetItemCount,
  setWidgetProductRandomItemCountSelectList,
} from '../../../../lib/utils/widgetUtils';
import { WIDGET_LAYOUT_MANUAL, WIDGET_TYPE } from '../../../../constants/service/app/widgetConstants';

class WidgetLayoutManualModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      initialWidgetLayoutTypePageNum: findIndex(
        WIDGET_LAYOUT_MANUAL[this.props.data.widgetType],
        (item) => item.layoutType === this.props.data.layoutType,
      ),
      widgetLayoutTypePageNum: findIndex(
        WIDGET_LAYOUT_MANUAL[this.props.data.widgetType],
        (item) => item.layoutType === this.props.data.layoutType,
      ),
    };
  }

  /**
   * 다음 버튼
   */
  next = () => {
    const { widgetLayoutTypePageNum } = this.state;
    const { data } = this.props;

    if (widgetLayoutTypePageNum < WIDGET_LAYOUT_MANUAL[data.widgetType].length) {
      this.setState({
        widgetLayoutTypePageNum: widgetLayoutTypePageNum + 1,
      });
    }
  };

  /**
   * 이전 버튼
   */
  prev = () => {
    const { widgetLayoutTypePageNum } = this.state;
    if (widgetLayoutTypePageNum > 0) {
      this.setState({
        widgetLayoutTypePageNum: widgetLayoutTypePageNum - 1,
      });
    }
  };

  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({ name: 'widgetLayoutManualModal', value: false });
  };

  /**
   * 데이터 변경
   */
  setData = (data) => {
    this.setState({
      [data.name]: data.value,
    });
  };

  /**
   * 레이아웃 타입 변경하기
   */
  changeLayoutType = async () => {
    const { initialWidgetLayoutTypePageNum, widgetLayoutTypePageNum } = this.state;
    const { setData, data, selectedWidgetItemCount, isRandomItem } = this.props;
    const { widgetType } = data;
    const layoutType = WIDGET_LAYOUT_MANUAL[widgetType][widgetLayoutTypePageNum].layoutType;

    if (widgetType === WIDGET_TYPE.BRAND || widgetType === WIDGET_TYPE.BANNER) {
      const checkBrandWidgetSelectedWidgetItemCountResult = await checkBrandAndBannerWidgetSelectedWidgetItemCount(
        widgetType,
        layoutType,
        selectedWidgetItemCount,
      );

      if (!checkBrandWidgetSelectedWidgetItemCountResult) {
        return;
      }
    }

    /**
     * 레이아웃 타입의 변경이 있다면, 레이아웃 타입 변경하기
     */
    if (initialWidgetLayoutTypePageNum !== widgetLayoutTypePageNum) {
      setData({
        path: ['widgetSave', 'widgetInfo', 'layoutType'],
        value: layoutType,
      });

      setData({
        path: ['widgetSave', 'widgetSection', 'isUsedTitleItem'],
        value: true,
      });

      if (isRandomItem) {
        const exposureItemCountSelectList = setWidgetProductRandomItemCountSelectList(layoutType);

        setData({
          path: ['widgetSave', 'widgetProductTypeInfo', 'productLayoutInfo', 'exposureItemCountSelectList'],
          value: exposureItemCountSelectList,
        });

        setData({
          path: ['widgetSave', 'widgetProductTypeInfo', 'productLayoutInfo', 'exposureItemCount'],
          value: exposureItemCountSelectList[0].id,
        });
      }
    }

    this.closeModal();
  };

  render() {
    return (
      <WidgetLayoutManualModal
        prev={this.prev}
        next={this.next}
        {...this.state}
        {...this.props}
        changeLayoutType={this.changeLayoutType}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.widget.widgetLayoutManualModal.isOpen,
    data: state.widget.widgetLayoutManualModal.data,
    selectedWidgetItemCount: state.widget.widgetSave.selectedWidgetItemList.list.length,
    isRandomItem: state.widget.widgetSave.widgetProductTypeInfo.productLayoutInfo.isRandomItem,
  };
};

const mapDispatchToProps = {
  setData: widgetActions.setData,
  toggleModal: widgetActions.toggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(WidgetLayoutManualModalContainer));
